var search = {
  pageResults: [],
  searchFailed: false,
  currentPage: 1,
  totalNumberOfPages: 1,
  totalNumberOfAgents: 0
};
export var teaserData = {
  isLoggedIn: false,
  staticTeaserData: {
    logoUrl: '',
    brandColor: '',
    displayName: '',
    message: '',
    linkDescription: '',
    linkUrl: '',
    agentPictureUrl: ''
  }
};
export var dynamicFaq = {
  sovEnabled: false,
  logoUrl: '',
  displayName: '',
  numberOfRegions: 0,
  positionList: [],
  selectedPosition: 0
};
var config = {};
var gacOverAllInfo = {
  suggestionGroups: [],
  selectedSuggestion: {
    name: '',
    value: '',
    geoPath: {
      uri: '',
      realNames: []
    },
    type: '',
    seoLabel: ''
  }
};
var tracking = {
  searchId: null
};
var seoData = {
  neighbourRegions: [],
  childrenRegions: [],
  childrenRegionType: '',
  neighbourRegionType: ''
};
var branchenbuchSearch = {
  isBranchenbuchSearch: false
};
var regionSeoContent = {
  blocks: []
};
var initialState = {
  search: search,
  config: config,
  gacOverAllInfo: gacOverAllInfo,
  tracking: tracking,
  seoData: seoData,
  branchenbuchSearch: branchenbuchSearch,
  teaserData: teaserData,
  dynamicFaq: dynamicFaq,
  regionSeoContent: regionSeoContent
};
export default initialState;